"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const gatsby_1 = require("gatsby");
const atoms_1 = require("@components/atoms");
const AccountInHeader_1 = require("@components/organisms/AccountInHeader");
const _store_1 = __importDefault(require("@store"));
const _theme_1 = require("@theme"); // Component
var AccountUpgraded = function AccountUpgraded() {
    var _useGlobal = _store_1.default(function (state) {
        return state.visibleDropdown;
    }, function (actions) {
        return actions.setVisibleDropdown;
    }), setVisibleDropdown = _useGlobal[1];
    var skip = function skip() {
        return setVisibleDropdown(undefined);
    };
    var _useGlobal2 = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal2[0];
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, {
        orderReverse: true,
        alignCenter: true
    }, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Header, {
        noPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "left",
        isDrawer: true
    }, "Account Upgraded"), (user === null || user === void 0 ? void 0 : user.tier) === 'community' && /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Welcome to Community"), (user === null || user === void 0 ? void 0 : user.tier) === 'bespoke' && /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Headline, null, "Welcome to Bespoke"), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Caption, null, "Start planning your next trip with featured ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/experiences"
    }, "experiences"), ", or start exploring ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/inspiration"
    }, "inspired"), " stories and ", /*#__PURE__*/ react_1.default.createElement(StyledLink, {
        to: "/destinations"
    }, "destinations"), "."), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.ButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, {
        to: "/experiences",
        size: "large",
        shadow: true
    }, "Get Started")))), /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.Column, null, /*#__PURE__*/ react_1.default.createElement(AccountInHeader_1.StyledImage, {
        src: "/images/accounts/welcome.png",
        objectFit: "contain"
    })));
};
var StyledLink = styled_components_1.default(gatsby_1.Link).withConfig({
    displayName: "AccountUpgraded__StyledLink",
    componentId: "i18ntc-0"
})(["color:", ";"], _theme_1.palette.brown);
exports.default = AccountUpgraded;
